import { ref } from 'vue';

const getCostcentres = () => {
    const costcentres_error = ref(null);
    const costcentres = ref(null);

    const loadCostcentres = async () => {
      try {
        let data = await fetch("/api/costcentres");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        costcentres.value = await data.json();

        // console.log('costcentres', costcentres.value);
      } catch (err) {
        costcentres_error.value = err.message;
      }
    };

    return { costcentres, costcentres_error, loadCostcentres};
}

export default getCostcentres;